
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evcharging/ev-charger",
      function () {
        return require("private-next-pages/evcharging/ev-charger.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evcharging/ev-charger"])
      });
    }
  